
import dayjs from "dayjs"
import gtm from "../components/topContent/gtm"
import sHeader from "@/components/sheader.vue"
import { orderInfoAfterPay } from "@/api/order.js"
import { trackPurchase } from "@/utils/track"
import { getDeliveryMethod } from "@/utils/utils"
import { getLanguage } from "@/plugins/i18n"

export default {
  components: {
    sHeader,
    gtm
  },
  layout: "onlyFooter",
  props: {},
  data() {
    return {
      loading: false,
      price: "",
      date: "",
      pickupDate: "",
      payItemInfoList: [],
      deliveryValue: "homeDelivery"
    }
  },
  computed: {},
  watch: {},
  mounted() {
    document.title = this.$t("pageTitle.payment")
    const query = this.$route.query
    if (query && Object.keys(query).length) {
      // this.price = query.price;
      // this.date = query.date;
      this.orderNo = query.orderNo
      this.orderList = query.orderList
      this.getOrderDetails()
      // this.deliveryValue = getDeliveryMethod()
    } else {
      this.$navigation.push({
        path: "/cart"
      })
      // window.location.href = `${this.MAIN_ORIGIN}${this.MAIN_PATH}/freView/#/cart`
    }
  },
  methods: {
    getViewDate(date) {
      date = dayjs(date)
      return getLanguage() == "en_US"
        ? `${this.$t("checkout.week")[date.day()]} ${date.date()} ${this.$t("checkout.month")[date.month()]},`
        : `${this.$t("checkout.month")[date.month()]}${date.date()}日（${this.$t("checkout.week")[date.day()]}）`
    },
    async getOrderDetails() {
      try {
        const { data: res } = await orderInfoAfterPay({
          param: JSON.stringify({
            orderId: this.orderNo,
            orderListStr: this.orderList
          })
        })
        if (res.frontOrderVO) {
          const frontOrderVO = res.frontOrderVO
          this.price = frontOrderVO.orderPrice
          this.date = this.getViewDate(frontOrderVO.shipStartTime) + " " + frontOrderVO.shipmentTime
          this.pickupDate = this.$t("paymentSuccessful.pickUpDate", {
            date: frontOrderVO && frontOrderVO.orderTagObj && frontOrderVO.orderTagObj.selfPickupDaysInterval
          })
          trackPurchase(frontOrderVO)
        }
      } catch (error) {
        console.log(error)
      }
    },
    fen2Yuan(num) {
      if (isNaN(num)) return ""
      num = Number(num)
      return (num / 100).toFixed(2)
    },
    getNumber(nums) {
      const num = this.fen2Yuan(nums)
      const str = num.toString()
      const res = str.split(".")
      return res[0]
    },
    getSmallNumber(nums) {
      const num = this.fen2Yuan(nums)
      const str = num.toString()
      const res = str.split(".")
      return res.length === 2 ? res[1] : ""
    },
    goHome() {
      this.$navigation.replace({
        path: "/"
      })
    },
    goOrder() {
      this.$navigation.push({ name: "order_list", query: { page: 1 } })
    }
  }
}
